import React from "react";
import type { TemplateMeta } from "@/api/templates";
import { ensureTemplateVariant } from "../../lib/templates/normalize";
import { PreviewCard, resolveVariant } from "./PreviewCard";
import { DynamicTemplate } from "./dynamic/DynamicTemplate";

// Returns a component that decides at render time based on the provided template prop.
// Backward compatible: if an initial TemplateMeta is passed, it will be used as a fallback
// when no template prop is provided. This avoids stale previews caused by closures.
export function resolveRenderComponent(initial?: TemplateMeta): React.FC<any> {
  const Wrapped: React.FC<any> = (props: any) => {
    const t: TemplateMeta = props.template || initial;
    if (!t) return null as any;
    // Dynamic templates (self-describing spec). Support v1, v2, and any future 'dynamic-*' renderer ids.
    if ((typeof (t as any).renderer === 'string' && (t as any).renderer.startsWith('dynamic')) || (t as any).spec) {
      return <DynamicTemplate template={props.template || t} {...props} />;
    }
    // Static templates: normalize componentKey to known variant slug and pass through meta/spec
    const variantKey = ensureTemplateVariant(t.componentKey as any, (t as any)?.variant);
    const resolved = resolveVariant(variantKey || (t as any)?.componentKey || "professional-classic");
    const metaForPreview = {
      componentKey: (t as any)?.componentKey,
      variant: (t as any)?.variant,
      accent: (t as any)?.accent,
    } as any;
    return (
      <PreviewCard
        {...props}
        variant={resolved as any}
        templateMeta={props.templateMeta ?? metaForPreview}
        templateSpec={props.templateSpec ?? ((t as any)?.spec || null)}
      />
    );
  };
  return Wrapped;
}
